import axios from 'axios';

export default {
  isSoftLoggedIn,
  loadCustomer,
  updateCustomer,
  updatePassword,
  smsOptInOut,
  setMarketingPreferences,
  getMarketingPreferences,
  getPaginatedPurchaseHistory,
  getOrderSummary,
  getOrderDataForColorSolution,
  getCustomerRecentInvoices,
  getCustomerCdata,
  getSignInData,
  verifyCipherStr,
  resetPassword,
  forgotPassword,
  sendPasswordResetSMS,
  facebookLogin,
  login,
  assignCustomerPromo,
  getCustomInstructions,
  createCustomerFromEmailCapture,
  getHairGoalRecsBySubscriptionId
};

export function getHairGoalRecsBySubscriptionId(subscriptionId) {
  return axios.get('/api/customer/getHairGoalRecsBySubscriptionId', { params: { subscriptionId } });
}

export function isSoftLoggedIn() {
  return axios.post('/api/customer/isSoftLoggedIn');
}

export function loadCustomer() {
  return axios.get('/api/customer/getCustomerInfo', { params: {} });
}

export function updateCustomer(customerInfo) {
  return axios.post('/api/account/updateAccount', customerInfo);
}

export function updatePassword(passwordData) {
  return axios.post('/api/customer/updatePassword', passwordData);
}

export function smsOptInOut(params) {
  return axios.post('/api/customer/smsOptInOut', params);
}

export function setMarketingPreferences(params) {
  return axios.post('/api/customer/setMarketingPreferences', params);
}

export function getMarketingPreferences() {
  return axios.get('/api/customer/getMarketingPreferencesByUserId');
}

export function getCustomerRecentInvoices() {
  return axios.get('/api/customer/getCustomerRecentInvoices');
}

export function getPaginatedPurchaseHistory(page, size) {
  return axios.get('/api/customer/getPaginatedPurchaseHistory', {
    params: {
      page: page,
      size: size
    }
  });
}

export function getOrderSummary(orderId) {
  return axios.get('/api/account/getOrderSummary', {
    params: { orderId }
  });
}

export function getOrderDataForColorSolution(params) {
  return axios.get('/api/account/getOrderDataForColorSolution', { params });
}

export function getCustomerCdata() {
  return axios.get('/api/customer/getCustomerCdata');
}

export function getSignInData() {
  return axios.get('/api/customer/getSignInData');
}

export function verifyCipherStr(params) {
  return axios.get('/api/customer/verifyCipherStr', { params });
}

export function resetPassword(params) {
  return axios.post('/api/customer/resetPassword', params);
}

export function forgotPassword(params) {
  return axios.post('/api/customer/forgotPassword', params);
}

export function sendPasswordResetSMS(params) {
  return axios.post('/api/customer/sendPasswordResetSMS', params);
}

export function facebookLogin(params) {
  return axios.post('/api/customer/facebookLogin', params);
}

export function login(params) {
  return axios.post('/api/customer/login', params);
}

export function createCustomer(params) {
  return axios.post('/api/customer/createCustomer', params);
}

export function assignCustomerPromo(params) {
  return axios.post('/api/customer/assignCustomerPromo', params);
}

export function getCustomInstructions() {
  return axios.get('/api/customer/getAllCustomInstructionsForCustomer');
}

export function createCustomerFromEmailCapture(formData) {
  return axios.post('/api/customer/createCustomerFromEmailCapture', formData);
}